var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 16L19 21.192C14.7517 22.2693 10.2483 22.2693 6 21.192L7.85714 16M17.1429 16H7.85714M17.1429 16L17.1429 14.187C17.1429 13.5043 16.5193 12.9508 15.75 12.9508C14.9807 12.9508 14.3571 12.3974 14.3571 11.7146L14.3571 11.3026H13.8027M7.85714 16L7.85714 14.187C7.85714 13.5043 8.48075 12.9508 9.25 12.9508C10.0193 12.9508 10.6429 12.3974 10.6429 11.7146V11.3026H11.3502M9.25 19.1317L8.77674 21.7384M12.5 18.284L12.5 21.9994M15.75 19.1317L16.2712 21.7316M13.8027 11.3026L13.857 3.17784C13.857 1.60739 11.4045 1.60739 11.4045 3.17784L11.3502 11.3026M13.8027 11.3026H11.3502",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.24951ff1aaff992a92b463a26bdf0805.svg";
export { ForwardRef as ReactComponent };